var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDaUndefinedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00000054",
    height: 25,
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.751 167.751"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 83.875c0 46.249 37.626 83.875 83.875 83.875s83.875-37.626 83.875-83.875S130.125 0 83.875 0 0 37.626 0 83.875zm83.875 68.876C45.897 152.751 15 121.854 15 83.875c0-16.292 5.698-31.272 15.191-43.078l96.762 96.762c-11.806 9.493-26.785 15.192-43.078 15.192zm68.875-68.876c0 16.292-5.698 31.272-15.19 43.078L40.797 30.191C52.603 20.698 67.583 15 83.875 15c37.978 0 68.875 30.897 68.875 68.875z"
  })));
}

export default SvgDaUndefinedIcon;